(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legal-document"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',async(event)=>{
 const button=event.target.closest('[data-legal-cookie]');
 if(!button)return;
 const error=button.parentElement.querySelector('.lp-cookie-error');
 try{
  if(!window.privacyBanner?.showPreferences)throw new Error('not-ready');
  await window.privacyBanner.showPreferences();
  error.hidden=true;
 }catch{error.hidden=false;}
});
  } catch(e) { console.error(e); }
})();

})();
